/**
 * 项目默认配置项
 */
export default {
  title: "载望志愿", // 页面title名字
  loginRoutePath: "/sso",
  homePath: "/home", // 设置主页路由地址
  whiteList: ["/sso", "/about"], // 白名单,仅B端使用
};
